import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import { CommerceToolsApi } from '@grandvisionhq/commercetools';
import { ProductDetailDescriptionView } from '@grandvisionhq/fun-products';
import { useIntl } from '@grandvisionhq/state';
import { getSolutionsFeatures } from '../../utils/get-solutions-features.js';
import SolutionsFeatures from '../SolutionsFeatures/SolutionsFeatures.js';
import SolutionsProductDetails from '../SolutionsProductDetails/SolutionsProductDetails.js';
import { useProductDetailContext } from '../../../Context/ProductDetailContext.js';
import { ProductDetailSpecificationContainer } from '../../../../ProductDetailSpecification/ProductDetailSpecificationContainer.js';

const Description = ()=>{
    const { getLabel  } = useIntl();
    const { activeVariant  } = useProductDetailContext();
    if (!CommerceToolsApi.isSolutions(activeVariant)) {
        return null;
    }
    const labels = React__default.useMemo(()=>({
            description: activeVariant.description,
            header: activeVariant.header || getLabel('products.solutions.header.header'),
            title: getLabel('products.solutions.header.details') || 'Product Details',
            targetUsers: activeVariant.targetUsers,
            convenience: activeVariant.convenience,
            keyInstructions: activeVariant.keyInstructions,
            disclaimer: getLabel('products.solutions.features.disclaimer')
        })
    , [
        getLabel,
        activeVariant
    ]);
    const { productFeatures , solutionsFeatures  } = React__default.useMemo(()=>getSolutionsFeatures(activeVariant, getLabel)
    , [
        getLabel,
        activeVariant
    ]);
    return /*#__PURE__*/ React__default.createElement(ProductDetailDescriptionView, {
        title: labels.header,
        description: labels.description
    }, /*#__PURE__*/ React__default.createElement(SolutionsFeatures, swcHelpers.extends({}, solutionsFeatures)), /*#__PURE__*/ React__default.createElement(SolutionsProductDetails, {
        targetUsers: labels.targetUsers,
        convenience: labels.convenience,
        keyInstructions: labels.keyInstructions,
        headerTitle: labels.title
    }), /*#__PURE__*/ React__default.createElement(ProductDetailSpecificationContainer, {
        fallbackConfiguration: productFeatures
    }), labels.disclaimer);
};

export { Description };
//# sourceMappingURL=Description.js.map
